export enum FocusPayMerchantTitles {
	"Chief Executive Officer" = "CEO",
	"Chief Financial Officer" = "CFO",
	"Chief Operating Officer" = "COO",
	"Chief Information Officer" = "CIO",
	"Chief Strategy Officer" = "CSO",
	"President" = "PRES",
	"Vice President" = "VP",
	"Managing Member" = "MANAGINGMEMBER",
	"General Partner" = "GENERALPARTNER",
	"Managing Partner" = "MANAGINGPARTNER",
	"Partner" = "PARTNER",
	"Treasurer" = "TREASURER",
	"Director" = "DIRECTOR",
	"Other" = "OTHER",
}
